function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { forwardRef } from 'react';
import ReactDatePicker from 'react-datepicker';
import { CalendarIcon } from '@domain-group/fe-co-icon';
import Controls from './controls';
import { datePickerContainer, textInput, datePicker, calendarIcon } from '../styles/date-picker';
import { controls } from './controls/style';
import { jsx as ___EmotionJSX } from "@emotion/core";
class DatePicker extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "onDateChange", formattedDate => {
      var _this$props$onChange, _this$props;
      (_this$props$onChange = (_this$props = this.props).onChange) === null || _this$props$onChange === void 0 ? void 0 : _this$props$onChange.call(_this$props, formattedDate);
      this.setState({
        selectedDate: formattedDate
      });
      if (this.props.autoClose !== false) {
        this.close();
      }
    });
    _defineProperty(this, "onTriggerClick", event => {
      event.preventDefault();
      if (this.isShowing()) {
        this.close();
      } else {
        this.open();
      }
    });
    _defineProperty(this, "onCalendarClick", event => {
      event.preventDefault();
      event.stopPropagation();
    });
    _defineProperty(this, "isShowing", () => {
      if (typeof this.props.showing !== 'undefined') {
        return this.props.showing;
      }
      return Boolean(this.state.showing);
    });
    _defineProperty(this, "open", () => {
      var _this$props$onOpen, _this$props2;
      (_this$props$onOpen = (_this$props2 = this.props).onOpen) === null || _this$props$onOpen === void 0 ? void 0 : _this$props$onOpen.call(_this$props2);
      this.setState({
        showing: true
      });
    });
    _defineProperty(this, "clear", () => {
      if (this.props.onClear) {
        this.props.onClear();
      } else {
        this.setState({
          selectedDate: null
        });
      }
    });
    _defineProperty(this, "close", () => {
      var _this$props$onClose, _this$props3;
      if (!this.isShowing()) {
        return;
      }
      (_this$props$onClose = (_this$props3 = this.props).onClose) === null || _this$props$onClose === void 0 ? void 0 : _this$props$onClose.call(_this$props3);
      this.setState({
        showing: false
      });
    });
    _defineProperty(this, "formatDate", date => date ? new Date(date) : date);
    _defineProperty(this, "renderControls", () => {
      var _this$props4 = this.props,
        enableControls = _this$props4.enableControls,
        trigger = _this$props4.trigger;
      if (!(enableControls && trigger)) {
        return null;
      }
      return ___EmotionJSX(Controls, {
        onClearClick: this.clear,
        onCloseClick: this.close
      });
    });
    this.state = {
      selectedDate: this.props.selected ? null : this.formatDate(this.props.initialDate),
      showing: false
    };
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.selected) {
      this.setState({
        selectedDate: null
      });
    }
    if (typeof nextProps.showing !== 'undefined' && typeof this.props.showing === 'undefined') {
      this.setState({
        showing: undefined
      });
    }
  }
  render() {
    var _this$props5 = this.props,
      todayButton = _this$props5.todayButton,
      trigger = _this$props5.trigger,
      _this$props5$alignToT = _this$props5.alignToTrigger,
      alignToTrigger = _this$props5$alignToT === void 0 ? 'left' : _this$props5$alignToT,
      enableControls = _this$props5.enableControls,
      isInvalid = _this$props5.isInvalid,
      inputIcon = _this$props5.inputIcon,
      isStatic = _this$props5.isStatic,
      showTimeSelect = _this$props5.showTimeSelect,
      _this$props5$timeForm = _this$props5.timeFormat,
      timeFormat = _this$props5$timeForm === void 0 ? 'HH:mm' : _this$props5$timeForm,
      _this$props5$dateForm = _this$props5.dateFormat,
      dateFormat = _this$props5$dateForm === void 0 ? 'dd/MM/yyyy' : _this$props5$dateForm,
      _this$props5$timeInte = _this$props5.timeIntervals,
      timeIntervals = _this$props5$timeInte === void 0 ? 30 : _this$props5$timeInte,
      childElements = _this$props5.childElements,
      showCalendarIcon = _this$props5.showCalendarIcon,
      innerRef = _this$props5.innerRef;
    var triggerElement;
    var hasTrigger = Boolean(trigger) && typeof trigger !== 'string';
    if (hasTrigger) {
      triggerElement = ___EmotionJSX("div", {
        onClick: this.onTriggerClick
      }, /*#__PURE__*/React.cloneElement(trigger, {
        showing: this.isShowing(),
        selectedDate: this.state.selectedDate || this.formatDate(this.props.selected),
        onChange: this.onDateChange
      }));
    }
    var datePickerElement;
    if (!hasTrigger || this.isShowing()) {
      datePickerElement = ___EmotionJSX("div", {
        css: datePickerContainer(alignToTrigger, hasTrigger, enableControls),
        onClick: this.onCalendarClick
      }, this.renderControls(), ___EmotionJSX(ReactDatePicker, _extends({}, this.props, {
        ref: innerRef,
        timeIntervals,
        dateFormat,
        timeFormat,
        inline: hasTrigger,
        css: textInput(isInvalid),
        dropdownMode: "scroll",
        onChange: this.onDateChange,
        selected: this.state.selectedDate || this.formatDate(this.props.selected),
        "data-testid": "date-picker__input"
      })), showCalendarIcon ? ___EmotionJSX(CalendarIcon, {
        css: calendarIcon,
        className: "date-picker-calendar-icon"
      }) : inputIcon, childElements && ___EmotionJSX("div", {
        css: controls
      }, childElements));
    }
    return ___EmotionJSX("div", {
      css: datePicker(Boolean(todayButton), alignToTrigger, hasTrigger, isStatic, showTimeSelect)
    }, triggerElement, datePickerElement);
  }
}
var RefForwardedDatePicker = /*#__PURE__*/forwardRef((props, ref) => ___EmotionJSX(DatePicker, _extends({}, props, {
  innerRef: ref
})));
export { RefForwardedDatePicker as DatePicker };